import script from "./SaveConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaveConfirmModal.vue?vue&type=script&setup=true&lang=ts"

import "./SaveConfirmModal.vue?vue&type=style&index=0&id=e0b56e80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0b56e80"]])

export default __exports__